export const DELETE_DL_USER = "DELETE_DL_USER";
export const SET_DL_USER = "SET_DL_USER";
export const SET_CONTRIBUTOR = "SET_CONTRIBUTOR";
export const CHANGE_Dl_STATUS = "CHANGE_Dl_STATUS";
export const CHANGE_PRE_MEMBERSHIP = "CHANGE_PRE_MEMBERSHIP";
export const ADD_Dl_USER = "ADD_Dl_USER";
export const DL_PROGRAM_UNENROLL = "DL_PROGRAM_UNENROLL";
export const EDIT_Dl_USER = "EDIT_Dl_USER";
